import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaAtractivos from './TablaAtractivos';

const Atractivos: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <TablaAtractivos />
    </Box>
  );
};

export default Atractivos;
